import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { CHAT_MESSAGE_SPACING } from "@src/appV2/Chat/constants";
import type { ReactNode } from "react";

import { ChatSeparator } from "./ChatSeparator";

interface ChatWidgetWrapperProps {
  headerText?: string;
  children: ReactNode;
}

export function ChatWidgetWrapper(props: ChatWidgetWrapperProps) {
  const { children, headerText } = props;

  return (
    <Stack gap={CHAT_MESSAGE_SPACING} marginY={CHAT_MESSAGE_SPACING}>
      {isDefined(headerText) && <ChatSeparator>{headerText}</ChatSeparator>}
      {children}
    </Stack>
  );
}
